import classnames from 'classnames/bind'
import React, { useEffect, useRef, useState } from 'react'

import { ImageProps } from '~/components/Image'
import { LinkProps } from '~/components/Link'
import { RichTextBlock } from '~/components/RichText'

import useScrollTrigger from '~/hooks/useScrollTrigger'

import { Language } from '~/data/page-data/meta'

import NavigationDesktop, { NavigationItemProps } from './NavigationDesktop'
import NavigationMobile from './NavigationMobile'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface NavigationLinkProps {
  title?: RichTextBlock[]
  navigationItem?: NavigationItemProps
}

export interface NavigationProps {
  logo?: ImageProps
  login?: LinkProps | NavigationItemProps
  register?: LinkProps
  items?: (NavigationItemProps | LinkProps)[]
  alternateLangs?: Language[]
  ariaHidden?: boolean
}
/**
 * Navigation component
 * @param props
 * @returns Component
 */
function Navigation(props: NavigationProps) {
  const componentRef = useRef()
  const [isVisible, setIsVisible] = useState(false)

  useScrollTrigger(
    componentRef,
    {
      start: '600px 0%',
      end: '100% 0',
      onUpdate: ({ direction, isActive }) => {
        if (direction === 1 && isActive === true) {
          setIsVisible(false)
        } else if (direction === -1 && isActive === false) {
          setIsVisible(false)
        } else if (direction === -1 && isActive === true) {
          setIsVisible(true)
        }
      },
    },
    [],
  )

  return (
    <header className={cx(css.Navigation)}>
      <NavigationDesktop
        className={cx(css.hideOnSmallScreen, css.navItem)}
        isVisible={!isVisible}
        {...props}
      />
      <NavigationDesktop
        className={cx(css.hideOnSmallScreen, css.fixed, { visible: isVisible })}
        isVisible={isVisible}
        ariaHidden={true}
        {...props}
      />
      <NavigationMobile className={cx(css.hideOnLargeScreen)} {...props} />
    </header>
  )
}

Navigation.defaultProps = {}

export default Navigation
